export default __webpack_public_path__ + "static/media/ThaiSansNeue-SemiBold.cede16db.otf";